<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual id="bigdata" title="Solution" src="/images/sub/subvisual-solution.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first">
            <template #titleLine>
                AI Big Data
            </template>
            <tit-wrap-large class="mb-0">
                <b>AI & Big Data Based Agriculture</b> <br class="d-none d-lg-block" />It leads you to easier, more systematic future agriculture.
                <template #text>As IReis’s differentiating point, root zone data provides innovative ideas and solutions in agriculture.</template>
            </tit-wrap-large>
        </page-section>

        <page-section class="d-flex align-center min-h-lg-980px">
            <div class="page-section__bg" style="background-image:url(/images/sub/solution/bigdata/bigdata-bg.jpg);"></div>
            <div data-aos="fade" data-aos-delay="100">
                <v-divider style="border-color: rgba(255,255,255,0.2)" />
                <div class="py-20px py-md-40px py-xl-80px text-center">
                    <div class="tit-wrap tit-wrap--sm white--text">
                        <h4 class="tit tit--lg">AI Big Data suggesting a sustainable future agriculture</h4>
                    </div>
                    <div class="txt txt--xl white--text">IReis provides agricultural recipes optimized for the crop production environment by collecting and analyzing daily over  <br class="d-none d-lg-block" />200 million cases of data obtained from farms. We suggest a variety of data-based agricultural solutions to future food shortages that may result from population growth, climate change, water shortages, etc.</div>
                </div>
                <v-divider style="border-color: rgba(255,255,255,0.2)" />
            </div>
        </page-section>

        <page-section-image imageSrc="/images/sub/solution/bigdata/bigdata-img.jpg" reverse>
            <template #title>
                <h4 class="tit tit--lg letter-spacing-n04">AI and big data-based root zone solution that suggests easier agriculture</h4>
            </template>
            <template #text>
                Root zone information is significant and differentiated data in agriculture. Our system diagnoses issues of the cultivation environment and provides farmers with a decision-making dashboard concerning the recognition of and solution to the state of crops based on data, enabling them to predict and respond to different agricultural variables.
            </template>
        </page-section-image>

        <page-section-image class="page-section--last" imageSrc="/images/sub/solution/bigdata/bigdata-img2.jpg">
            <template #title>
                <h4 class="tit tit--lg">Operation of useful and accurate data-based smart farms</h4>
            </template>
            <template #text>
                Our system optimizes the growth and yield of your crops by monitoring the growth conditions of the crops based on our root zone data accumulated over ten years Data-based agriculture helps farmers cultivate crops in a smarter way.
            </template>
        </page-section-image>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";
import PageSectionImage from "@/pages/client/templates/page-section-image.vue";
import TitWrapSmall from "@/components/dumb/tit-wrap-small.vue";
import TitWrapLarge from "@/components/dumb/tit-wrap-large.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        PageSectionImage,
        TitWrapSmall,
        TitWrapLarge,
    },
    props: {},
    data() {
        return {
            tab: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {});
        },
    },
};
</script>

<style lang="scss" scoped></style>
